import { IconButton, InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';

const PREFIX = 'SearchBox';

const classes = {
  searchName: `${PREFIX}-searchName`,
};

const StyledInputAdornment = styled(InputAdornment)(({ theme }) => ({
  [`& .${classes.searchName}`]: {
    display: 'flex',
    align: 'center',
    width: '100%',
  },
}));

interface Props {
  title: string;
  search(value: string): void;
  size?: 'small' | 'medium';
  useSecondaryColor?: boolean;
  defaultValue?: string;
  onValueChange?(value: string): void;
}

function SearchBox({
  title,
  search,
  size = 'medium',
  useSecondaryColor = true,
  defaultValue = '',
  onValueChange,
}: Props) {
  const [value, setValue] = useState<string>(defaultValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    onValueChange?.(newValue);
  };

  const searchPressed = () => {
    search(value);
  };

  return (
    <TextField
      id="name"
      label={title}
      autoComplete="off"
      onChange={handleChange}
      defaultValue={value}
      className={classes.searchName}
      size={size}
      fullWidth={true}
      InputProps={{
        endAdornment: (
          <StyledInputAdornment position="end">
            <IconButton
              size={size}
              aria-label="search"
              onClick={() => searchPressed()}>
              <SearchIcon color={useSecondaryColor ? 'secondary' : undefined} />
            </IconButton>
          </StyledInputAdornment>
        ),
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          searchPressed();
        }
      }}
    />
  );
}

export default SearchBox;
